import { useCreateEvent } from "@api/eventService";
import EventEdit from "./EventEdit";

export default function EventCreate() {
    return <EventEdit
        mutation={useCreateEvent}
        title={'New Event'}
        create
    />
}
